import React from 'react'
import { Link } from 'gatsby'

type Props = {
  url: string,
  type: 'internal' | 'external',
  title?: string,
  newTab: boolean,
  children: React.ReactChild,
  className?: string,
  activeClassName?: string,
}

export const CustomLink: React.FC<Props> = ({
  url,
  type,
  title,
  newTab,
  children,
  activeClassName = '',
  className = '',
}) => {
  if (type === 'internal')
    return (
      <Link to={url} activeClassName={activeClassName} className={className} title={title}>
        {children || title}
      </Link>
    )
  if (type === 'external')
    return (
      <a
        href={url}
        rel="noreferrer"
        target={newTab ? '_blank' : ''}
        className={className}
        title={title}
      >
        {children}
      </a>
    )
  return <p>UNKNOWN LINK TYPE</p>
}
